<div class="cta-card-opt2-container">
  <div class="cta-card-opt2">
    <!-- Image -->
    @if (block.data.hasImage) {
      <div class="cta-card-opt2__panel cta-card-opt2__panel--img">
        <img class="img-fluid" [src]="imageUrl" [alt]="block.data.heading" />
      </div>
    }

    <!-- Card -->
    <div class="cta-card-opt2__panel cta-card-opt2__panel--content">
      <h3 class="cta-card-opt2__panel-heading" [innerText]="block.data.heading | translate"></h3>

      <div class="cta-card-opt2__panel-description" [innerHTML]="block.data.description | translate"></div>

      @if (buttonData) {
        <core-coro-button [button]="buttonData"></core-coro-button>
      }
    </div>
  </div>
</div>
